module.exports = __webpack_public_path__ + "static/bg.df334416.png";